import { SVGProps, Ref, forwardRef } from 'react';

export const CircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M8 .5c5.625 0 7.5 3.75 7.5 7.5s-1.875 7.5-7.5 7.5S.5 11.75.5 8 2.375.5 8 .5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CircleFilledSize16Glyph.displayName = 'CircleFilledSize16Glyph';
